import v1ReleaseNotes from "@/../RELEASES.md?raw";
import { GithubRepositoryRelease } from "@/gql/__generated__/graphql";

export const v1Release: GithubRepositoryRelease = {
  id: "v1.0.0",
  name: "v1.0.0",
  body: v1ReleaseNotes,
  publishedAt: new Date("Dec 2, 2024")
};
